import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { GLASS_CONSTANT, GLASS_NAME_CONSTANT } from './GlassConstant';
import {COATING_NAME_CONSTANT, SAMPLE_COATING_NAME_CONSTANT} from './CoatingConstant';
import {
    INTERLAYER_CONSTANT,
    INTERLAYER_NAME_CONSTANT,
    SAMPLE_INTERLAYER_CONSTANT,
    SAMPLE_INTERLAYER_NAME_CONSTANT
} from './InterlayerConstant';
import { AIR_CONSTANT, AIR_NAME_CONSTANT } from './AirConstant';
import IconDownArrow from '../Icon/IconDownArrow';
import { PRINT_CONSTANT, PRINT_NAME_CONSTANT } from './PrintConstant';
import {AIR_SPACE_COLOR_TYPE, HEAT_TREATMENT, SIGHTLINE} from './SampleConstant';

const selectData = {
    G: { options: GLASS_NAME_CONSTANT, sampleOptions:  GLASS_NAME_CONSTANT,source: GLASS_CONSTANT, sampleSource: GLASS_CONSTANT},
    A: { options: AIR_NAME_CONSTANT, sampleOptions:  AIR_NAME_CONSTANT, source: AIR_CONSTANT, sampleSource: AIR_CONSTANT },
    I: { options: INTERLAYER_NAME_CONSTANT, sampleOptions:  SAMPLE_INTERLAYER_NAME_CONSTANT, source: INTERLAYER_CONSTANT, sampleSource: SAMPLE_INTERLAYER_CONSTANT },
    S: { options: COATING_NAME_CONSTANT, sampleOptions: SAMPLE_COATING_NAME_CONSTANT, source: [], sampleSource: []}
};

const thicknessMap = {
    '1/8 - 3mm': 0.125,
    '5/32 - 4mm': 0.15625,
    '3/16 - 5mm': 0.1875,
    '1/4 - 6mm': 0.25,
    '5/16 - 8mm': 0.3125,
    '5/16 - 7.5mm': 0.3125,
    '3/8 - 10mm': 0.375,
    '3/8 - 9mm': 0.375,
    '7/16 - 11mm': 0.4375,
    '15/32 - 11.9mm': 0.46875,
    '15/32 - 12mm': 0.46875,
    '1/2 - 12mm': 0.5,
    '1/2 - 13.2mm': 0.5,
    '9/16 - 14.2mm': 0.5625,
    '9/16 - 14mm': 0.5625,
    '5/8 - 15.5mm': 0.625,
    '23/32 - 18.2mm': 0.71875,
    '23/32 - 18mm': 0.71875,
    '3/4 - 18.5mm': 0.75,
    '7/8 - 22.2mm': 0.875,
    '7/8 - 22mm': 0.875,
    '1 - 25.4mm': 1
};

const SurfaceDropdown = ({
     defaultOption,
     selectType,
     title,
     id,
     surfaceIndex,
     handleFunction,
     handleThicknessFunction,
     extraHandleFunction,
     extraHandleThicknessFunction,
     defaultValue,
     defaultThickness,
     defaultExtraValue,
     defaultExtraThickness,
     isOpenDefault,
     handleHeatTreatment,
     handleAirMaterialAndColor,
     handleAirSightline,
     heatTreatment,
     airMaterialAndColor,
     sampleCustomField,
     handleP1Extra,
     handleP2Extra,
     type,
 }) => {
    const [selectOptions, setSelectOptions] = useState([]);
    const [extraSelectOptions, setExtraSelectOptions] = useState([]);
    const [selectThicknessOptions, setSelectThicknessOptions] = useState([]);
    const [isOpen, setIsOpen] = useState(isOpenDefault);
    const [mainSelectValue, setMainSelectValue] = useState(defaultValue);
    const [extraSelectValue, setExtraSelectValue] = useState('');
    const [thicknessSelectValue, setThicknessSelectValue] = useState(defaultThickness);
    const [extraThicknessSelectValue, setExtraThicknessSelectValue] = useState('');
    const [heatTreatmentValue, setHeatTreatmentValue] = useState('');
    const [materialColorValue, setMaterialColorValue] = useState('');
    const [sightlineValue, setSightlineValue] = useState('');
    const [isPrint, setIsPrint] = useState(false);
    const [isExtraSilkScreen, setIsExtraSilkScreen] = useState(true);

    const handleToggleAccordion = () => {
        setIsOpen(!isOpen);
    };

    function handleExtraTextFieldChange(event) {
        const { value } = event.target.value;
        setExtraThicknessSelectValue(event.target.value);

        if(event.target.value < 0) {
            setExtraThicknessSelectValue(0);
        }

        extraHandleThicknessFunction({
            id,
            value: event.target.value > 0  ? event.target.value : '',
            surfaceIndex,
            isExtra: isExtraSilkScreen});
    };

    useEffect(() => {
        setExtraSelectOptions(PRINT_NAME_CONSTANT);
        if(type === 'Sample') {
            setSelectOptions(selectData[selectType].sampleOptions);
            selectData[selectType].sampleSource.filter(element => element.name === defaultValue).map((item) => (
                setSelectThicknessOptions(item.thickness)
            ))
        } else{
            setSelectOptions(selectData[selectType].options);
            selectData[selectType].source.filter(element => element.name === defaultValue).map((item) => (
                setSelectThicknessOptions(item.thickness)
            ))
        }

        /* switch (selectType) {
            case 'G':
                setSelectOptions(GLASS_NAME_CONSTANT);
                GLASS_CONSTANT.filter(element => element.name === defaultValue).map((item) => (
                    setSelectThicknessOptions(item.thickness)
                ))
                break;
            case 'A':
                setSelectOptions(AIR_NAME_CONSTANT);
                AIR_CONSTANT.filter(element => element.name === defaultValue).map((item) => (
                    setSelectThicknessOptions(item.thickness)
                ))
                break;
            case 'I':
                setSelectOptions(INTERLAYER_NAME_CONSTANT);
                INTERLAYER_CONSTANT.filter(element => element.name === defaultValue).map((item) => (
                    setSelectThicknessOptions(item.thickness)
                ))
                break;
            case 'S':
                setSelectOptions(COATING_NAME_CONSTANT);
                break;
            default:
                break;
        } */
    }, [])

    function getBackgroundColor() {
        switch (selectType) {
            case 'G':
                return '#8FBCD8';
            case 'A':
                return '#DAE3EC';
            case 'I':
                return '#b1c0c9';
            case 'S':
                return '#d4e1f3';
            default:
                break;
        }
    }

    function getThicknessBackgroundColor() {
        switch (selectType) {
            case 'G':
                return '#3291CA';
            case 'I':
                return '#718B97';
            case 'A':
                return '#9DB3BD';
            default:
                break;
        }
    }

    function handleMainSelectChange(event) {
        const { value } = event.target;
        setMainSelectValue(value);

        if(selectType === 'G') {
            setThicknessSelectValue('1/4 - 6mm');
            handleThicknessFunction({
                id,
                value: 0.25,
                surfaceIndex,
                isPrint});
        } else if (selectType === 'I') {
            setThicknessSelectValue('');
            handleThicknessFunction({
                id,
                value: type === 'Sample'
                    ?
                    selectData[selectType].sampleSource.filter(element => element.name === event.target.value)[0].thickness[0]
                    :
                    selectData[selectType].source.filter(element => element.name === event.target.value)[0].thickness[0],
                surfaceIndex,
                isPrint});
        }  else {
            setThicknessSelectValue('');
            handleThicknessFunction({
                id,
                value: '',
                surfaceIndex,
                isPrint});
        }

        let printValue = '';
        if(isPrint) {
            const matchedElement = PRINT_CONSTANT.find(element => element.name === event.target.value);
            printValue = matchedElement.code;
        }

        handleFunction({
            id,
            value: isPrint ? printValue : event.target.value,
            surfaceIndex});

        const selectedConstant = type === 'Sample' ? selectData[selectType].sampleSource : selectData[selectType].source;

        if (selectedConstant) {
            selectedConstant.filter(element => element.name === event.target.value).map((item) => (
                setSelectThicknessOptions(item.thickness)
            ))
        } else {
            handleThicknessFunction({
                id,
                value: 100,
                surfaceIndex,
                isPrint});
        }
    }

    function handleExtraSelectChange(event) {
        const { value } = event.target;
        setExtraSelectValue(value);

        let printValue = '';
        const matchedElement = PRINT_CONSTANT.find(element => element.name === event.target.value);
        printValue = matchedElement.code;

        extraHandleFunction({
            id,
            value: printValue,
            surfaceIndex});

        const selectedConstant = selectData[selectType].source;

        if (selectedConstant) {
            const matchedType = selectedConstant.find(element => element.name === value);
            if (matchedType?.thickness) {
                setSelectThicknessOptions(matchedType.thickness);
            }
        } else {
            extraHandleThicknessFunction({
                id,
                value: extraThicknessSelectValue !== '' ? extraThicknessSelectValue : 100,
                surfaceIndex,
                isExtra: isExtraSilkScreen
            });
        }
    }

    function handleThicknessSelectChange(event) {
        const { value } = event.target;
        setThicknessSelectValue(value);
        let nominalThickness = event.target.value;

        if (selectType !== 'I') {
            nominalThickness = thicknessMap[value] ?? 0.25;
        }

        handleThicknessFunction({
            id,
            value: nominalThickness,
            surfaceIndex,
            isPrint});
    }

    function handleGlassHeatTreatment(event) {
        const { value } = event.target;
        setHeatTreatmentValue(value);

        handleHeatTreatment({
            id,
            value: event.target.value,
            surfaceIndex});
    }

    function handleMaterialAndColor(event) {
        const { value } = event.target;
        setMaterialColorValue(value);

        handleAirMaterialAndColor({
            id,
            value: event.target.value,
            surfaceIndex});
    }

    function handleSightline(event) {
        const { value } = event.target;
        setSightlineValue(value);

        handleAirSightline({
            id,
            value: event.target.value,
            surfaceIndex});
    }

    function handleExtraSampleValues(event, eventType, p1 , p2){

        if(p1) {
            handleP1Extra(prev => ({
                ...prev,
                [eventType]: event.target.value,
                id,
                surfaceIndex,
            }));
        }

        if(p2) {
            handleP2Extra(prev => ({
                ...prev,
                [eventType]: event.target.value,
                id,
                surfaceIndex,
            }));
        }
    }

    return (
        <div
            style={{ backgroundColor: getBackgroundColor() }}
            className="flex flex-col m-1 p-2 rounded"
        >
            {selectType !== 'A' &&
                <button
                    type="button"
                    className="flex flex-row pl-1 pb-1 font-normal"
                    onClick={handleToggleAccordion}
                >
                    <div className="flex flex-row justify-between w-full">
                        <h2>{title}</h2>
                        <IconDownArrow />
                    </div>
                </button>
            }
            {(isOpen && (selectType === 'G' || selectType === 'I')) &&
                <div className="flex flex-row">
                    <div className="flex flex-col w-2/3 pr-4">
                        <select
                            value={mainSelectValue}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            onChange={handleMainSelectChange}
                        >
                            <option value="">{defaultOption}</option>
                            {selectOptions.map((item) => (
                                <option key={item} value={item}>
                                    {item}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="flex flex-col w-1/3">
                        <select
                            value={thicknessSelectValue}
                            className="border border-gray-300 text-white text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            onChange={handleThicknessSelectChange}
                            style={{backgroundColor: getThicknessBackgroundColor()}}
                        >
                            {selectThicknessOptions.map((item) => (
                                <option key={item} value={item}>
                                    {item}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            }
            {isOpen && selectType === 'G' && sampleCustomField &&
                <div className="flex flex-col w-2/3 pr-4 pt-2">
                    <select
                        value={heatTreatmentValue}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                        onChange={handleGlassHeatTreatment}
                        style={{backgroundColor: '#FFFFFF'}}
                    >
                        <option selected>Select</option>
                        {HEAT_TREATMENT.map((item) => (
                            <option key={item.id} value={item.name}>
                                {item.name}
                            </option>
                        ))}
                    </select>
                </div>
            }
            {selectType === 'A' &&
                <div className="flex flex-row">
                    <div className="flex flex-col w-2/3 pr-4">
                        <select
                            value={mainSelectValue}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            onChange={handleMainSelectChange}
                        >
                            {selectOptions.map((item) => (
                                <option key={item} value={item}>
                                    {item}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="flex flex-col w-1/3">
                        <select
                            value={thicknessSelectValue}
                            className="border border-gray-300 text-white text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            onChange={handleThicknessSelectChange}
                            style={{backgroundColor: getThicknessBackgroundColor()}}
                        >
                            {selectThicknessOptions.map((item) => (
                                <option key={item} value={item}>
                                    {item}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            }
            {isOpen && selectType === 'A' && sampleCustomField &&
                <>
                    <div className="flex flex-col w-2/3 pr-4 pt-2">
                        <select
                            value={materialColorValue}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            onChange={handleMaterialAndColor}
                            style={{backgroundColor: '#FFFFFF'}}
                        >
                            <option selected>Select Air Space Color Type</option>
                            {AIR_SPACE_COLOR_TYPE.map((item) => (
                                <option key={item.id} value={item.name}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="flex flex-col w-2/3 pr-4 pt-2">
                        <select
                            value={sightlineValue}
                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                            onChange={handleSightline}
                            style={{backgroundColor: '#FFFFFF'}}
                        >
                            <option selected>Select Sightline</option>
                            {SIGHTLINE.map((item) => (
                                <option key={item.id} value={item.name}>
                                    {item.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </>
            }
            {isOpen && (selectType === 'S') && (
                <div className="flex flex-row pr-4 items-center justify-center">
                    {!isPrint &&
                        <div className="flex flex-col w-full">
                            <div className="flex flex-row w-full">
                                <div className="flex flex-col w-3/5">
                                    <select
                                        value={mainSelectValue}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                        onChange={handleMainSelectChange}
                                    >
                                        {selectOptions.map((item) => (
                                            <option key={item} value={item}>
                                                {item}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            {isExtraSilkScreen && !sampleCustomField &&
                                <div className="flex flex-row w-full mt-2">
                                    <div className="flex flex-col w-3/5">
                                        <select
                                            value={extraSelectValue}
                                            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            onChange={handleExtraSelectChange}
                                        >
                                            {extraSelectOptions.map((item) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="flex flex-col w-2/5 pl-4">
                                        <input
                                            type="number"
                                            min="0"
                                            className="w-full h-full text-center rounded text-sm"
                                            placeholder="Coverage %"
                                            onChange={handleExtraTextFieldChange}
                                            value={defaultExtraThickness !== '' ? defaultExtraThickness : extraThicknessSelectValue}
                                        />
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>
            )}
            {isOpen && (selectType === 'S') && sampleCustomField &&
                <>
                    <div className="flex flex-row pr-4 items-center justify-center pt-2">
                        <div className="flex flex-col w-1/4">
                            <input
                                type="text"
                                min="0"
                                className="w-full h-full text-center rounded text-sm p-2"
                                placeholder="Silkscreen"
                                onChange={(e) => handleExtraSampleValues(e, 'silkscreen', true, false)}
                                value={null}
                            />
                        </div>
                        <div className="flex flex-col w-1/4 pl-1">
                            <input
                                type="text"
                                min="0"
                                className="w-full h-full text-center rounded text-sm p-2"
                                placeholder="Color"
                                onChange={(e) => handleExtraSampleValues(e, 'color', true, false)}
                                value={null}
                            />
                        </div>
                        <div className="flex flex-col w-1/4 pl-1">
                            <input
                                type="text"
                                min="0"
                                className="w-full h-full text-center rounded text-sm p-2"
                                placeholder="Spandrel"
                                onChange={(e) => handleExtraSampleValues(e, 'spandrel', true, false)}
                                value={null}
                            />
                        </div>
                        <div className="flex flex-col w-1/4 pl-1">
                            <input
                                type="text"
                                min="0"
                                className="w-full h-full text-center rounded text-sm p-2"
                                placeholder="Digital Print"
                                onChange={(e) => handleExtraSampleValues(e, 'digitalPrint', true, false)}
                                value={null}
                            />
                        </div>
                    </div>
                    <div className="flex flex-row pr-4 items-center justify-center pt-2">
                        <div className="flex flex-col w-1/4">
                            <input
                                type="text"
                                min="0"
                                className="w-full h-full text-center rounded text-sm p-2"
                                placeholder="Silkscreen"
                                onChange={(e) => handleExtraSampleValues(e, 'silkscreen', false, true)}
                                value={null}
                            />
                        </div>
                        <div className="flex flex-col w-1/4 pl-1">
                            <input
                                type="text"
                                min="0"
                                className="w-full h-full text-center rounded text-sm p-2"
                                placeholder="Color"
                                onChange={(e) => handleExtraSampleValues(e, 'color', false, true)}
                                value={null}
                            />
                        </div>
                        <div className="flex flex-col w-1/4 pl-1">
                            <input
                                type="text"
                                min="0"
                                className="w-full h-full text-center rounded text-sm p-2"
                                placeholder="Spandrel"
                                onChange={(e) => handleExtraSampleValues(e, 'spandrel', false, true)}
                                value={null}
                            />
                        </div>
                        <div className="flex flex-col w-1/4 pl-1">
                            <input
                                type="text"
                                min="0"
                                className="w-full h-full text-center rounded text-sm p-2"
                                placeholder="Digital Print"
                                onChange={(e) => handleExtraSampleValues(e, 'digitalPrint', false, true)}
                                value={null}
                            />
                        </div>
                    </div>
                </>
            }
        </div>
    );
}

SurfaceDropdown.propTypes = {
    defaultOption: PropTypes.string.isRequired,
    selectType: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    surfaceIndex: PropTypes.number.isRequired,
    handleFunction: PropTypes.func.isRequired,
    handleThicknessFunction: PropTypes.func.isRequired,
    extraHandleFunction: PropTypes.func,
    extraHandleThicknessFunction: PropTypes.func,
    defaultValue: PropTypes.string,
    defaultThickness: PropTypes.string,
    defaultExtraValue: PropTypes.string,
    defaultExtraThickness: PropTypes.string,
    isOpenDefault: PropTypes.bool,
    handleHeatTreatment: PropTypes.func,
    handleAirMaterialAndColor: PropTypes.func,
    handleAirSightline: PropTypes.func,
    heatTreatment: PropTypes.string,
    airMaterialAndColor: PropTypes.string,
    sampleCustomField: PropTypes.bool,
    handleP1Extra: PropTypes.func,
    handleP2Extra: PropTypes.func,
    type: PropTypes.string,
}

SurfaceDropdown.defaultProps = {
    extraHandleFunction:  () => undefined,
    extraHandleThicknessFunction:  () => undefined,
    handleHeatTreatment:  () => undefined,
    handleAirMaterialAndColor:  () => undefined,
    handleAirSightline:  () => undefined,
    handleP1Extra:  () => undefined,
    handleP2Extra:  () => undefined,
    defaultValue: '',
    defaultThickness: '',
    defaultExtraValue: '',
    defaultExtraThickness: '',
    isOpenDefault: false,
    heatTreatment: '',
    airMaterialAndColor: '',
    sampleCustomField: false,
    type: 'Configuration'
};

export default SurfaceDropdown;